import { dynamicLoader } from '~/utils';

export const CompaniesPage = dynamicLoader({
  name: 'CompaniesPage',
  importFunc: () => import('./companies'),
});